module.exports = __webpack_public_path__ + "static/media/IMG_8912.099775d3.JPG";